// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore,  doc, getDoc } from 'firebase/firestore/lite';
import { getAuth, signInWithCustomToken, onAuthStateChanged, signOut  } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app)

export {app, db, doc, getDoc, getAuth, signInWithCustomToken, onAuthStateChanged, signOut }

//travelerportal portal ->tracking vue